import { WageAndTravelStatus } from '@nkr/enums/watr-status'
import { Dispatch, connect } from 'react-redux';
import Verify from '.'
import { FileDocumentType, WageAndTravelCategory, WageAndTravelReimbursementRequestStatus } from '@nkr/enums/index'
import { useContext, useEffect, useState } from 'react';
import { IDonorShieldContext, DonorShieldContext, DonorShieldProvider } from '../context';
import { AppActionCreators, FileActionCreators, IApplicationState, IAppState, IWatrDetailsDataResponse, WatrActionCreators } from '@nkr/store/index';
import { IBaseResponse, IListItem, IWatrRequest } from '@nkr/models/index';
import { IWatrAuditLogResponse } from '@nkr/store/watr/actions';
import { Well, Alert } from 'react-bootstrap';
import { toast } from 'react-toastify';
import ClaimHistory from '../claim-history';
import { IDeclineSelectionPayload } from '../banking-decline-flags';
import { getBankingReviewTerminology } from '../banking-review-terminology';
import Decline from '../modals/decline';

interface IProps {
    isSuperUser: boolean,
    centerId: number,
    requestId: number
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    // getRequestList: (centerId: number, category: WageAndTravelCategory, startDate: string, endDate: string, isSuperUser: boolean) => Promise<IWatrRequestResponse>,
    // searchRequests: (centerId: number, firstName: string, lastName: string, email: string, birthDate: string, alias: string, isAdmin: boolean) => Promise<IWatrRequestResponse>,
    // getRequestCounts: (centerId: number, category: WageAndTravelCategory, startDate: string, endDate: string, isAdmin: boolean) => Promise<IWatrRequestCountsResponse>,
    downloadFile: (docType: number, lookupId: number) => Promise<any>,
    getTravelDetails: (centerId: number, requestId: number, isAdmin: boolean) => Promise<IWatrDetailsDataResponse>,
    // getReimbursementsByRequestId: (requestId: number) => Promise<IWatrReimbursementResponse>,
    // getRequestById: (centerId: number, requestId: number) => Promise<IWatrRequestResponse>,
    // getLogsByRequestId: (requestId: number) => Promise<IWatrLogsResponse>,
    // getRequestLookupData: (centerId: number, isSuperUser: boolean) => Promise<IWatrRequestLookupDataResponse>,
    // updateDonorRequest: (reqId: number, firstName: string, lastName: string, email: string, mobile: string, birthDate: string, expirationDate: string,
    //     achAccountNumber: string, achRoutingNumber: string, intBankingNumber: string, intSwiftNumber: string, isSuperUser: boolean) => Promise<IWatrRequestUpdateResponse>
    // saveReimbursementEntry: (requestId: number, type: number, amount: number, confirmationCode: string, date: string) => Promise<IReimbursementEntryResponse>,
    // updateReimbursement: (requestId: number, reimbursementId: number, type: number, amount: number, confirmationCode: string, date: string) => Promise<IReimbursementEntryResponse>,
    saveLogEntry: (requestId: number, type: number, comments: string, file: File) => Promise<IWatrAuditLogResponse>,
    updateLogEntry: (requestId: number, logId: number, type: number, comments: string, file: File) => Promise<IWatrAuditLogResponse>,
    deleteLogEntry: (requestId: number, logId: number) => Promise<IWatrAuditLogResponse>,
    // verifyAmount: (requestId: number, status: WageAndTravelStatus, sendEmail: boolean, amount: number) => Promise<IWatrRequestUpdateResponse>,
    // verifyStub: (requestId: number, startDate: string, endDate: string, amount: number) => Promise<IWatrRequestUpdateResponse>,
    // verifyTax: (requestId: number, ssnEncrypted: string, incomeIrsYear: number, incomeIrsYearGross) => Promise<IWatrRequestUpdateResponse>,
    // verifyTravel: (requestId: number, roundTripMiles: number, hotelLodgingExpense: number, flightAndTrainExpense: number, carServiceExpense: number, dependentCareExpense: number,
    //     mealExpense: number, isMilesOverWritten: boolean, overrideMiles: number, isMealsOverWritten: boolean, overrideMeals: number
    // ) => Promise<IWatrRequestUpdateResponse>,
    // addReimbursement: (requestId: number, type: number, date: string, amount: number, confirmation: string) => Promise<IBaseResponse>,
    // requestAdditionalDays: (requestId: number, additionalDays: number, additionalDaysSignOff, drFullNameSignOff) => Promise<IBaseResponse>,
    declineRequest: (requestId: number, emailSubject: string, firstParagraph: string, emailContent: string, lastParagraph: string, isTravel: boolean, isFixable: boolean, bccCenter: boolean, wageRepairRequested?: boolean, bankingRoutingRequiresReview?: boolean, bankingAccountRequiresReview?: boolean, declineReasonSummary?: string) => Promise<IBaseResponse>,
    declineTravelRequest: (travelRequestId: number, emailSubject: string, firstParagraph: string, emailContent: string, lastParagraph: string, isFixable: boolean, bccCenter: boolean, declineReasonSummary?: string) => Promise<IBaseResponse>,
    getTripsByTravelRequestId: (travelRequestId: number) => Promise<any>,
    getLineItemsByTripId: (tripId: number) => Promise<any>,
    approveTrip: (tripId: number, requestId: number, requiresEmail: boolean) => Promise<any>,
    // cancelRequest: (requestId: number) => Promise<IBaseResponse>,
    // confirmDonation: (requestId: number, signOffInitials: string) => Promise<IBaseResponse>,
    // updateDonationDate: (requestId: number, donationDate: string) => Promise<IBaseResponse>,
    // resendInvitation: (requestId: number) => Promise<IBaseResponse>,
    // updateAudit: (requestId: number, type: WageAndTravelType, status: WageAndTravelStatus, reimbursementAmount: number, donationDate: string, incomePercentCovered: number) => Promise<IWatrRequestUpdateResponse>,
    // updateReimbursementStatus: (centerId: number, list: {
    //     requestId: number,
    //     week: number,
    //     status: WageAndTravelReimbursementRequestStatus,
    //     additionalWeeksDrSignOff?: string,
    //     additionalWeeksReason?: number,
    //     additionalWeeksReasonOther?: string
    // }[]) => Promise<IBaseResponse>,
    // getChaseListExport: () => Promise<IWatrChaseExportListResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

/*
donationTypes: IListItem[],
requestTypes: IListItem[],
statusTypes: IListItem[],
auditLogTypes: IListItem[],
reimbursementTypes: IListItem[],
*/

const VerifyPage = (props: TProps) => {
    const [data, setData] = useState<IWatrRequest>(null);
    const [donationTypes, setDonationTypes] = useState<IListItem[]>([]);
    const [requestTypes, setRequestTypes] = useState<IListItem[]>([]);
    const [statusTypes, setStatusTypes] = useState<IListItem[]>([]);
    const [auditLogTypes, setAuditLogTypes] = useState<IListItem[]>([]);
    const [logActionTypes, setLogActionTypes] = useState<IListItem[]>([]);
    const [reimbursementTypes, setReimbursementTypes] = useState<IListItem[]>([]);
    const [showClaimHistory, setShowClaimHistory] = useState(false);
    const [showReceipts, setShowReceipts] = useState(false);
    const [receiptsTotalFiles, setReceiptsTotalFiles] = useState<number>(1);
    const [receiptsFileIds, setReceiptsFileIds] = useState<number[]>([]);
    const [receiptsCurrentIndex, setReceiptsCurrentIndex] = useState<number>(0);
    const [receiptsFileIdToLineItemsMap, setReceiptsFileIdToLineItemsMap] = useState<Map<number, any[]>>(new Map());
    const [receiptsOnApproveLineItems, setReceiptsOnApproveLineItems] = useState<((lineItemIds: number[]) => Promise<void>) | undefined>(undefined);
    const [receiptsOnRequestReviewLineItems, setReceiptsOnRequestReviewLineItems] = useState<((lineItemIds: number[]) => Promise<void>) | undefined>(undefined);
    const [decline, setDecline] = useState<{ show: boolean, isTravel: boolean, travelId: number, hasLineItemsSelected?: boolean }>({ show: false, isTravel: false, travelId: 0 });
    const [title, setTitle] = useState('Verify');

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        props.showLoading('Loading request, one moment please...').then(() => {
            props.getTravelDetails(props.centerId, props.requestId, props.isSuperUser).then(response => {
                if (response.data.success) {
                    setData(response.data.results.watrBasicDetail);
                }
            }).finally(() => {
                props.hideLoading();
            });
        });
    }

    const handleShowDataSideBar = (docType: number, lookupId: number, fileUrl?: string, totalFiles?: number, fileIds?: number[], currentIndex?: number, fileIdToLineItemsMap?: Map<number, any[]>, onApproveLineItems?: (lineItemIds: number[]) => Promise<void>, onRequestReviewLineItems?: (lineItemIds: number[]) => Promise<void>, onExpenseTypeChange?: (expenseType: number | null) => void, onExpenseTypeApproved?: (expenseType: number) => void, onRefreshLineItems?: () => Promise<void>, onReviewRequiredStateChange?: (lineItemIds: number[], reviewRequired: boolean) => void) => {
        if (docType == FileDocumentType.DonorShieldClaimHistory) {
            setShowClaimHistory(!showClaimHistory);
        }

        if (docType == FileDocumentType.Receipts) {
            if (totalFiles !== undefined) {
                setReceiptsTotalFiles(totalFiles);
            }
            if (fileIds !== undefined) {
                setReceiptsFileIds(fileIds);
            }
            if (currentIndex !== undefined) {
                setReceiptsCurrentIndex(currentIndex);
            }
            if (fileIdToLineItemsMap !== undefined) {
                setReceiptsFileIdToLineItemsMap(fileIdToLineItemsMap);
            }
            if (onApproveLineItems !== undefined) {
                setReceiptsOnApproveLineItems(() => onApproveLineItems);
            }
            if (onRequestReviewLineItems !== undefined) {
                setReceiptsOnRequestReviewLineItems(() => onRequestReviewLineItems);
            }
            setShowReceipts(true);
        }
    }

    const fetchFileUrl = (docType: FileDocumentType, lookupId: number): Promise<string> => {
        return props.downloadFile(docType, lookupId)
            .then((response: any) => {
                const fileUrl = URL.createObjectURL(response.data);
                return fileUrl;
            })
            .catch((error) => {
                console.error('Error fetching file:', error);
                //throw error;
                return null;
            });
    };

    const handleSaveLogEntry = (type: number, comments: string, file: File) => {
        // let message = 'Creating log entry, one moment please...';
        // let reqId = state.view.data.id;

        // props.showLoading(message).then(() => {
        //     props.saveLogEntry(reqId, type, comments, file)
        //         .then(response => {
        //             if (response.data.success) {

        //                 //get data in view
        //                 //update state of view
        //                 let viewData = _.cloneDeep(state.view.data);

        //                 if (viewData.logs == undefined)
        //                     viewData.logs = [];

        //                 viewData.logs.push(response.data.results);

        //                 setState({
        //                     view: {
        //                         show: true,
        //                         type: WageAndTravelViewType.RequestData,
        //                         data: viewData,
        //                         reimbursements: state.view.reimbursements
        //                     }
        //                 }, () => {
        //                     props.hideLoading();
        //                     toast.success('Log entry updated successfully');
        //                 });
        //             } else {
        //                 props.hideLoading();
        //                 toast.error('Unable to create entry');
        //             }
        //         })
        //         .catch((error: AxiosError) => {
        //             props.hideLoading();
        //         });
        //     ;
        // });
    };

    const handleUpdateLogEntry = (logId: number, type: number, comments: string, file: File) => {
        // let message = 'Creating log entry, one moment please...';
        // let reqId = state.view.data.id;

        // props.showLoading(message).then(() => {
        //     props.updateLogEntry(reqId, logId, type, comments, file)
        //         .then(response => {
        //             if (response.data.success) {
        //                 let logId = response.data.results.id;

        //                 let list = _.cloneDeep(state.list).map(item => {
        //                     if (item.id == reqId) {
        //                         item.logs = item.logs.map(logItem => {
        //                             if (logItem.id == logId)
        //                                 return response.data.results;

        //                             return logItem;
        //                         })
        //                     }

        //                     return item;
        //                 });

        //                 let data = list.find(x => x.id == reqId);

        //                 setState({
        //                     list,
        //                     view: {
        //                         show: true,
        //                         type: WageAndTravelViewType.RequestData,
        //                         data,
        //                         reimbursements: state.view.reimbursements
        //                     }
        //                 }, () => {
        //                     props.hideLoading();
        //                     toast.success('Log entry updated successfully');
        //                 });
        //             } else {
        //                 toast.error('Unable to create entry');
        //             }

        //             props.hideLoading();
        //         })
        //         .catch((error: AxiosError) => {
        //             props.hideLoading();
        //         });
        //     ;
        // });
    };

    const handleDeleteLogEntry = (logId: number) => {
        // let reqId = state.view.data.id;

        // props.showLoading('Deleting log entry, one moment please...').then(() => {
        //     props.deleteLogEntry(reqId, logId)
        //         .then(response => {
        //             if (response.data.success) {
        //                 let list = _.cloneDeep(state.list).map(item => {
        //                     if (item.id == reqId) {
        //                         item.logs = item.logs.filter(logItem => logItem.id != logId);
        //                     }
        //                     return item;
        //                 });

        //                 let data = list.find(x => x.id == reqId);

        //                 setState({
        //                     list,
        //                     view: {
        //                         type: WageAndTravelViewType.RequestData,
        //                         show: true,
        //                         data,
        //                         reimbursements: state.view.reimbursements
        //                     }
        //                 }, () => {
        //                     props.hideLoading();
        //                     toast.success('Log entry delete successfully');
        //                 });
        //             }
        //         })
        //         .catch((error: AxiosError) => {
        //             props.hideLoading();
        //         });
        //     ;
        // });
    };

    const handleUpdateTitle = (newTitle: string) => {
        setTitle(newTitle);
    };

    const handleShowDeclineModal = (requestId: number, isTravel: boolean = false, travelId: number = 0, hasLineItemsSelected?: boolean) => {
        setDecline({
            show: true,
            isTravel,
            travelId: travelId || 0,
            hasLineItemsSelected
        });
    };

    const handleDeclineRequest = (requestId: number, emailSubject: string, firstParagraph: string, emailContent: string, lastParagraph: string, isFixable: boolean, bccCenter: boolean, selection: IDeclineSelectionPayload) => {
        const declineRequestId = decline.isTravel && decline.travelId > 0 ? decline.travelId : props.requestId;

        props.showLoading('Loading data...').then(() => {
            props.declineRequest(declineRequestId, emailSubject, firstParagraph, emailContent, lastParagraph, decline.isTravel, isFixable, bccCenter, selection.wageRepairRequested, selection.bankingRoutingRequiresReview, selection.bankingAccountRequiresReview, selection.declineReasonSummary).then(async response => {
                props.hideLoading();

                if (response.data.success) {
                    const declineData = response.data as { success: boolean; warning?: string; Warning?: string };
                    const archiveWarning = declineData.warning || declineData.Warning;
                    if (archiveWarning) {
                        toast.warn(archiveWarning);
                    }
                    setDecline({ show: false, isTravel: false, travelId: 0, hasLineItemsSelected: undefined });
                    await props.getTravelDetails(props.centerId, props.requestId, true);
                    if (window.location.reload) {
                        setTimeout(() => window.location.reload(), 500);
                    }
                } else {
                    const errorMessage = response.data?.results || response.data?.message || 'An error occurred while declining the request.';
                    toast.error(errorMessage);
                }
            }).catch(err => {
                props.hideLoading();
                const errorMessage = err?.response?.data?.results || err?.response?.data?.message || err?.message || 'An error occurred while declining the request.';
                toast.error(errorMessage);
            });
        });
    };

    const handleCloseDecline = () => {
        setDecline({ show: false, isTravel: false, travelId: 0 });
    }

    const contextValue: IDonorShieldContext = {
        isNkrSuper: props.isSuperUser,
        currentUser: props.app.user,
        auditLogTypes: auditLogTypes,
        logActionTypes: logActionTypes,
        donationTypes: donationTypes,
        reimbursementTypes: reimbursementTypes,
        statusTypes: statusTypes,
        requestTypes: requestTypes,
        onShowDataSideBar: handleShowDataSideBar,
        fetchFileUrl: fetchFileUrl,
        downloadFile: props.downloadFile,
        handleSaveLogEntry: handleSaveLogEntry,
        handleUpdateLogEntry: handleUpdateLogEntry,
        handleDeleteLogEntry: handleDeleteLogEntry,
        onReimbursementEntry: null,
        onReimbursementUpdate: null,
        onUpdateTitle: handleUpdateTitle,
        onShowDeclineModal: handleShowDeclineModal,
        onVerifyPayStub: (requestId: number, startDate: string, endDate: string, grossAmount: number, paystubs: any[], requiresEmail: boolean, ssnDecrypted?: string) => null,
        onVerifyTax: () => null,
        onVerifyTravel: (travelRequestId: number, requestId: number, roundTripMiles: number, hotelLodgingExpense: number, flightAndTrainExpense: number, carServiceExpense: number, dependentCareExpense: number,
            mealExpense: number, isMilesOverWritten: boolean, overrideMiles: number, isMealsOverWritten: boolean, overrideMeals: number,
            isCarServiceExpenseOverridden: boolean, overrideCarServiceExpense: number,
            isDependentCareExpenseOverridden: boolean, overrideDependentCareExpense: number,
            isHotelLodgingExpenseOverridden: boolean, overrideHotelLodgingExpense: number,
            requiresEmail: boolean) => null,
        onVerifyAmount: () => null,
        onGetTripsByTravelRequestId: async (travelRequestId: number) => {
            const response = await props.getTripsByTravelRequestId(travelRequestId);
            return response.data?.Results || [];
        },
        onGetLineItemsByTripId: async (tripId: number) => {
            const response = await props.getLineItemsByTripId(tripId);
            return response.data?.Results || [];
        },
        onApproveTrip: async (tripId: number, requestId: number, requiresEmail: boolean) => {
            return await props.approveTrip(tripId, requestId, requiresEmail);
        },
        onDeclineRequest: async (requestId: number, emailSubject: string, firstParagraph: string, emailContent: string, lastParagraph: string, isTravel: boolean, isFixable: boolean, bccCenter: boolean, wageRepairRequested?: boolean, bankingRoutingRequiresReview?: boolean, bankingAccountRequiresReview?: boolean) => {
            if (isTravel && decline.travelId > 0) {
                return await props.declineTravelRequest(decline.travelId, emailSubject, firstParagraph, emailContent, lastParagraph, isFixable, bccCenter);
            }
            return await props.declineRequest(requestId, emailSubject, firstParagraph, emailContent, lastParagraph, isTravel, isFixable, bccCenter, wageRepairRequested, bankingRoutingRequiresReview, bankingAccountRequiresReview);
        }
    };

    const bankingTerms = data != null ? getBankingReviewTerminology(data.country, data.isUsBank) : null;

    return (
        <>
            <DonorShieldProvider value={contextValue}>
                <div>
                    <h4>{title}</h4>
                    {data != null && bankingTerms != null && (data.bankingRoutingRequiresReview || data.bankingAccountRequiresReview) && (
                        <Alert bsStyle="warning" style={{ marginTop: 8 }}>
                            <strong>Banking correction required:</strong>{' '}
                            {data.bankingRoutingRequiresReview && <span>{bankingTerms.routingReviewAlert}</span>}
                            {data.bankingAccountRequiresReview && <span>{bankingTerms.accountReviewAlert}</span>}
                        </Alert>
                    )}
                </div>
                <div style={{ display: 'flex' }}>
                    <div style={{ width: '49%' }}>
                        {data != null && (
                            <Verify
                                data={data}
                                isAudit={false}
                                reimbursements={[]}
                                category={WageAndTravelCategory.PendingDERVerify}
                                validation={undefined}
                                isDirty={false}
                            // onShowDeclineModal={handleShowDeclineModal}
                            />
                        )}
                    </div>
                    <div style={{ width: '2%' }}>&nbsp;</div>
                    <div style={{ width: '49%' }}>
                        {showClaimHistory && (
                            <ClaimHistory data={data} travels={data.requestTravels} />
                        )}

                        {/* {showReceipts && (
                            <Receipts />
                        )} */}
                    </div>
                </div>

                <Decline
                    show={decline.show}
                    data={data}
                    declineType={decline.isTravel ? 'Expense' : 'Lost Wage'}
                    onDeclineRequest={handleDeclineRequest}
                    onClose={handleCloseDecline}
                    hasLineItemsSelected={decline.hasLineItemsSelected}
                    claimDeclineResponseList={[]}
                />
            </DonorShieldProvider>
        </>
    );
}

// export default VerifyPage;

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        // getRequestList: (centerId, category, startDate, endDate, isSuperUser) => {
        //     return dispatch(WatrActionCreators.getRequestList(centerId, category, startDate, endDate, isSuperUser));
        // },
        // searchRequests: (centerId, firstName, lastName, email, birthDate, alias, isAdmin) => {
        //     return dispatch(WatrActionCreators.searchRequests(centerId, firstName, lastName, email, birthDate, alias, isAdmin));
        // },
        // getRequestCounts: (centerId, category, startDate, endDate, isAdmin) => {
        //     return dispatch(WatrActionCreators.getRequestCounts(centerId, category, startDate, endDate, isAdmin));
        // },
        getTravelDetails: (centerId, requestId, isAdmin) => {
            return dispatch(WatrActionCreators.getTravelDetails(centerId, requestId, isAdmin));
        },
        // getReimbursementsByRequestId: (requestId) => {
        //     return dispatch(WatrActionCreators.getReimbursementsByRequestId(requestId));
        // },
        // getRequestById: (centerId, requestId) => {
        //     return dispatch(WatrActionCreators.getRequestById(centerId, requestId));
        // },
        // getLogsByRequestId: (requestId) => {
        //     return dispatch(WatrActionCreators.getLogsByRequestId(requestId));
        // },
        // getRequestLookupData: () => {
        //     return dispatch(WatrActionCreators.getLookupData());
        // },
        // updateDonorRequest: (reqId, firstName, lastName, email, mobile, birthDate, expirationDate, achAccountNumber, achRoutingNumber, intBankingNumber, intSwiftNumber, isSuperUser) => {
        //     return dispatch(WatrActionCreators.updateDonorRequest(reqId, firstName, lastName, email, mobile, birthDate, expirationDate, achAccountNumber, achRoutingNumber, intBankingNumber, intSwiftNumber, isSuperUser));
        // },
        // saveReimbursementEntry: (requestId, type, amount, confirmationCode, date) => {
        //     return dispatch(WatrActionCreators.createReimbursement(requestId, type, amount, confirmationCode, date));
        // },
        // updateReimbursement: (requestId, reimbursementId, type, amount, confirmationCode, date) => {
        //     return dispatch(WatrActionCreators.updateReimbursement(requestId, reimbursementId, type, amount, confirmationCode, date));
        // },
        saveLogEntry: (requestId, type, comments, file) => {
            return dispatch(WatrActionCreators.createAuditLog(requestId, type, comments, file));
        },
        updateLogEntry: (requestId, logId, type, comments, file) => {
            return dispatch(WatrActionCreators.updateAuditLog(requestId, logId, type, comments, file));
        },
        deleteLogEntry: (requestId, logId) => {
            return dispatch(WatrActionCreators.deleteAuditLog(requestId, logId));
        },
        // verifyAmount: (requestId, status, sendEmail, amount) => {
        //     return dispatch(WatrActionCreators.verifyAmount(requestId, status, sendEmail, amount));
        // },
        // verifyStub: (requestId, startDate, endDate, grossAmount) => {
        //     return dispatch(WatrActionCreators.verifyStub(requestId, startDate, endDate, grossAmount));
        // },
        // verifyTax: (requestId, ssnEncrypted, irsYear, irsYearGross) => {
        //     return dispatch(WatrActionCreators.verifyTax(requestId, ssnEncrypted, irsYear, irsYearGross));
        // },
        // verifyTravel: (requestId, roundTripMiles, hotelLodgingExpense, flightAndTrainExpense, carServiceExpense, dependentCareExpense,
        //     mealExpense, isMilesOverWritten, overrideMiles, isMealsOverWritten, overrideMeals
        // ) => {
        //     return dispatch(WatrActionCreators.verifyTravel(requestId, roundTripMiles, hotelLodgingExpense, flightAndTrainExpense, carServiceExpense, dependentCareExpense,
        //         mealExpense, isMilesOverWritten, overrideMiles, isMealsOverWritten, overrideMeals
        //     ));
        // },
        // addReimbursement: (requestId, type, date, amount, confirmation) => {
        //     return dispatch(WatrActionCreators.addReimbursement(requestId, type, date, amount, confirmation));
        // },
        // requestAdditionalDays: (requestId, additionalDays, additionalDaysSignOff, drFullNameSignOff) => {
        //     return dispatch(WatrActionCreators.requestAdditionalDays(requestId, additionalDays, additionalDaysSignOff, drFullNameSignOff));
        // },
        declineRequest: (requestId, emailSubject, firstParagraph, emailContent, lastParagraph, isTravel, isFixable, bccCenter, wageRepairRequested, bankingRoutingRequiresReview, bankingAccountRequiresReview, declineReasonSummary) => {
            return dispatch(WatrActionCreators.declineRequest(requestId, emailSubject, firstParagraph, emailContent, lastParagraph, isTravel, isFixable, bccCenter, wageRepairRequested, bankingRoutingRequiresReview, bankingAccountRequiresReview, declineReasonSummary));
        },
        declineTravelRequest: (travelRequestId, emailSubject, firstParagraph, emailContent, lastParagraph, isFixable, bccCenter, declineReasonSummary) => {
            return dispatch(WatrActionCreators.declineTravelRequest(travelRequestId, emailSubject, firstParagraph, emailContent, lastParagraph, isFixable, bccCenter, declineReasonSummary));
        },
        // cancelRequest: (requestId) => {
        //     return dispatch(WatrActionCreators.cancelRequest(requestId));
        // },
        // confirmDonation: (requestId, signOffInitials) => {
        //     return dispatch(WatrActionCreators.confirmDonation(requestId, signOffInitials));
        // },
        // updateDonationDate: (requestId, donationDate) => {
        //     return dispatch(WatrActionCreators.updateDonationDate(requestId, donationDate));
        // },
        // updateAudit: (requestId, type, status, reimbursementAmount, donationDate, incomePercentCovered) => {
        //     return dispatch(WatrActionCreators.updateAudit(requestId, type, status, reimbursementAmount, donationDate, incomePercentCovered));
        // },
        downloadFile: (docType, lookupId) => {
            return dispatch(FileActionCreators.downloadFile(docType, lookupId));
        },
        getTripsByTravelRequestId: (travelRequestId) => {
            return dispatch(WatrActionCreators.getTripsByTravelRequestId(travelRequestId));
        },
        getLineItemsByTripId: (tripId) => {
            return dispatch(WatrActionCreators.getLineItemsByTripId(tripId));
        },
        approveTrip: (tripId, requestId, requiresEmail) => {
            return dispatch(WatrActionCreators.approveTrip(tripId, requestId, requiresEmail));
        },
        // resendInvitation: (requestId,) => {
        //     return dispatch(WatrActionCreators.resendInvitation(requestId));
        // },
        // updateReimbursementStatus: (centerId, list) => {
        //     return dispatch(ActionCenterActionCreators.updateReimbursementStatus(centerId, list))
        // },
        // getChaseListExport: () => {
        //     return dispatch(WatrActionCreators.getChaseExport());
        // }
    }
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(VerifyPage);